import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  promoImg: {
    width: '100%',
    marginBottom: '3.5rem'
  },
  tabTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: 8,
    color: theme.palette.text.secondary
  },
  contentContainer: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: 32
  },
  tableContainer: {
    maxWidth: 800,
    margin: '0 auto'
  },
  paragraph: {
    marginBottom: 16,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: theme.palette.text.primary
  }
}))
